import { GridElement } from '..'
import { Divider } from '../../components'

export const GridDivider: React.FC<GridElement> = props => {
    return <Divider />
}
